<template>
  <div class="view-container">
    <div class="application-container" v-loading="loading">
      <!-- 返回 -->
      <div class="logo flex items-center justify-center relative">
        <i class="el-icon-arrow-left absolute" @click="handleBackLogin">返回</i>
        <span>申请试用账号</span>
      </div>

      <!-- 申请表单 -->
      <el-form
        class="application-form"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="76px"
      >
        <template>
          <!-- 姓名 -->
          <el-form-item prop="nickname" label='姓名'>
            <el-input v-model="form.nickname" autocomplete="off" placeholder="请输入姓名" />
          </el-form-item>
          <!-- 单位 -->
          <el-form-item prop="org" label="单位">
            <el-input v-model="form.org" autocomplete="off" placeholder="请输入单位" />
          </el-form-item>
          <!-- 身份 -->
          <el-form-item prop="identity" label="身份" style="width: 70%" class="select-box">
            <el-select v-model="form.identity" placeholder="请选择身份">
              <el-option value="技术经理人" label="技术经理人" />
              <el-option value="企业研发人员" label="企业研发人员" />
              <el-option value="科研人员" label="科研人员" />
              <el-option value="其他" label="其他" />
            </el-select>
          </el-form-item>
          <!-- 手机号 -->
          <el-form-item prop="phone" label="手机号">
            <el-input v-model="form.phone" autocomplete="off" placeholder="请输入手机号" />
          </el-form-item>
          <!-- 动态切换验证码 -->
          <el-form-item prop="code" label="验证码">
            <el-row :gutter="10" class="flex items-center">
              <el-col :span="15">
                <el-input v-model="form.code" autocomplete="off" placeholder="请输入验证码" />
              </el-col>
              <el-col :span="9">
                <el-button
                  class="code-btn"
                  :disabled="!canSendCode"
                  @click="getVerifyCode"
                >
                  {{ codeBtnText }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item prop="email" label="邮箱">
            <el-input v-model="form.email" autocomplete="off" placeholder="请输入邮箱" />
          </el-form-item>
          <!-- 密码 -->
          <el-form-item prop="password" label="密码">
            <el-input v-model="form.password" show-password autocomplete="new-password" placeholder="请输入密码" />
          </el-form-item>
          <!-- 确认密码 -->
          <el-form-item prop="checkPass" label="确认密码">
            <el-input v-model="form.checkPass" show-password autocomplete="new-confirm-password" placeholder="请再次输入密码" />
          </el-form-item>
        </template>

        <!-- 提交按钮 -->
        <el-button type="primary" class="submit-btn" @click="handleSubmit">
          提交
        </el-button>
        <p class="tips">注：审核通过后，将通过短信通知您；后续请通过手机号+验证码/密码的形式登录</p>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sendCodeApi, } from '@/api/login';
import { addUserApi } from '@/api/register';

export default {
  name: 'registerApplication',
  components: {},
  data() {
    // 手机号
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    };
    // 密码
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度至少6位'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    // 确认密码
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      codeBtnText: '发送验证码', // 验证码按钮文字
      countdown: 59, // 倒计时
      isSend: false,  // 是否已经发送
      canSendCode: false, // 能否发送验证码
      timer: null, // 定时器对象
      loading: false,
      form: {
        nickname: '',
        org: '',
        identity: '',
        phone: '',
        code: '',
        email: '',
        password: '',
        checkPass: '',
      },
      rules: {
        nickname: [{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }],
        org: [{ required: true, message: '请输入单位', trigger: ['blur', 'change'] }],
        identity: [{ required: true, message: '请选择身份', trigger: ['blur', 'change'] }],
        phone: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        code: [{ required: true, message: '请输入验证码', trigger: ['blur', 'change'] }],
        email: [{ required: true, type: 'email', message: '请输入正确的邮箱', trigger: ['blur', 'change'] }],
        password: [{ required: true, validator: validatePass, trigger: ['blur', 'change'] }],
        checkPass: [{ required: true, validator: validatePass2, trigger: ['blur', 'change'] }],
      },
    };
  },
  computed: {
    computedSystemName() {
      return '科技成果转化AI助手';
    },
  },
  methods: {
    // 返回 登录
    handleBackLogin() {
      this.$router.push({ name: 'login' });
    },

    // 获取验证码
    async getVerifyCode() {

      // 防止重复发送
      if (this.isSend) {
        return;
      }

      this.isSend = true;

      try {
        // 调用获取验证码接口
        const res = await sendCodeApi({
          type: 'SignUp',
          phone: this.form.phone,
        });

        if (res.code == 200) {
          // 开始倒计时
          this.$message.success('验证码发送成功，请查收');
          this.canSendCode = false;
          this.timer = setInterval(() => {
            this.codeBtnText = `${this.countdown}s后重新发送`;
            if (this.countdown-- <= 0) {
              clearInterval(this.timer);
              this.isSend = false;
              this.canSendCode = true;
              this.codeBtnText = '发送验证码';
              this.countdown = 59;
            }
          }, 1000);
        } else {
          this.isSend = false;
          this.$message.error(res.message);
        }
      } catch (err) {
        this.isSend = false;
        console.log(err);
        // this.$message.error('验证码发送失败，请重试');
      }
    },

    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let pa = {
            ...this.form,
            username: this.form.phone,
          };
          delete pa.checkPass;

          // 调用接口
          addUserApi(pa)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.message);
                this.$refs.form.resetFields();
                setTimeout(() => {
                  this.handleBackLogin();
                }, 1000)
              } else {
                this.$message.error(res.message);
              }
              setTimeout(() => {
                this.loading = false;
              }, 1200);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },

  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.timer);
  },

  watch: {
    // 监听手机号，格式正确发送验证码按钮可点击
    'form.phone'(newVal) {
      this.canSendCode = !this.isSend && /^1[3-9]\d{9}$/.test(newVal);
    },
  },
};
</script>

<style scoped lang="less">
.view-container {
  width: 100vw;
  height: 100vh;
  min-width: 650px;
  min-height: 720px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.application-container {
  width: 580px;
  height: 690px;
  box-sizing: border-box;
  padding: 30px 0 30px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;

  .el-icon-arrow-left {
    color: #888888;
    left: 25px;
    font-size: 14px;
    user-select: none;
    cursor: pointer;
  }

  span {
    color: #2f70ff;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 1px;
    margin-left: 30px;
  }
}


.region-tip {
  height: 12px;
  color: rgba(153, 153, 153, 0.9);
  font-size: 13px;
  margin-bottom: 10px;
  text-align: center;
}

.application-form {
  width: 82%;
  margin: 0 auto;

  /deep/ .el-form-item__label {
    white-space: nowrap !important;
  }

  /deep/.el-input__inner {
    border-width: 2px;
    border-radius: 8px;
  }

  /deep/ .el-input.is-active .el-input__inner,
  /deep/ .el-input__inner:focus {
    border-color: #2f70ff;
  }

  .code-btn {
    border-radius: 8px !important;
    border-width: 2px;
    width: 100%;
    padding: 11px 10px !important;
  }

  .code-btn:not(.is-disabled):focus,
  .code-btn:not(.is-disabled):hover {
    color: #2f70ff;
    border-color: #2f70ff;
  }

  .agree-text {
    display: flex;

    /deep/ .el-checkbox__input {
      margin-top: 2px;
      margin-left: 2px;
    }

    .txt {
      white-space: pre-wrap;
      font-size: 13px;
      color: #404040;
    }
  }
}

.select-box {
  /deep/ .el-select .el-input__inner:focus {
    border-color: #2f70ff !important;
  }
}

.submit-btn {
  width: 100%;
  background: #2c7cff;
  margin-top: 14px;
  border-radius: 8px;
}

.tips {
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  font-size: 13px;
  margin-top: 8px;
  user-select: none;
}

.wechat-login {
  margin-top: 30px;
  text-align: center;
}


.divider {
  color: #ccc;
  margin: 20px 0;
  position: relative;
}

.divider:before,
.divider:after {
  content: '';
  border-top: 1px solid #eee;
  width: 45%;
  position: absolute;
  top: 50%;
}

.divider:before {
  left: 0;
}
.divider:after {
  right: 0;
}

.wechat-btn {
  color: #2c7cff;
  border-color: #2c7cff;
}

.icon-wechat {
  margin-right: 8px;
  font-size: 18px;
}
</style>
